module.exports = __webpack_public_path__ + "img/acaciaicon1.2c6f70f0.png";